import SEO from '../../components/SEO';
import React from 'react';
import { Link2 } from 'lucide-react';

import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

const CommunityResourcesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      
      <Navigation />
      <SEO title="Community Resources" description="Community-based mental health resources, social services navigation, and support connections through SDORA Wellbeing in Pikesville and Baltimore County, MD." path="/services/community-resources" />
      
      <div className="bg-gradient-to-br from-blue-50 to-purple-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-4">
            <Link2 className="w-12 h-12 text-blue-600" />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              Community Resources
            </h1>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl">
            Access to vital community resources and support networks to maximize individual and collective potential.
          </p>
        </div>
      </div>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">How We Connect You</h2>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Resource Navigation</h3>
                    <p className="text-gray-600">Expert guidance to find the right community services.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Support Groups</h3>
                    <p className="text-gray-600">Connect with others who understand your journey.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Community Links</h3>
                    <p className="text-gray-600">Partnerships with local organizations and services.</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mt-2"></span>
                  <div>
                    <h3 className="font-semibold text-lg">Ongoing Support</h3>
                    <p className="text-gray-600">Continued assistance accessing resources.</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-indigo-50 p-8 rounded-xl">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Available Resources</h2>
              <p className="text-gray-700 mb-4">We can help you access:</p>
              <ul className="space-y-2 text-gray-700">
                <li>• Housing assistance</li>
                <li>• Employment services</li>
                <li>• Financial aid programs</li>
                <li>• Transportation support</li>
                <li>• Food assistance</li>
                <li>• Legal services</li>
                <li>• Educational programs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default CommunityResourcesPage;